import React from 'react';

const ColorDot = () => (
  <div
    data-testid="color-dot"
    style={{
      width: 10,
      height: 10,
      borderRadius: 25,
    }}
    className="inline bg-plum"
  />
);

export default ColorDot;
